import i18n from "@/lib/i18n";
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { ProductSelectionSection } from "@/components/shared/ProductSelectionSection";
import { Package } from "lucide-react";
import { ProductSelection } from "@/types/product";

interface ProductSelectionModalProps {
  selectedProducts: ProductSelection[];
  onProductsChange: (products: ProductSelection[]) => void;
  showPricing?: boolean;
  disabled?: boolean;
  triggerText?: string;
  title?: string;
  size?: "sm" | "default" | "lg";
}

export const ProductSelectionModal: React.FC<ProductSelectionModalProps> = ({
  selectedProducts,
  onProductsChange,
  showPricing = true,
  disabled = false,
  triggerText = i18n.t("components.quotes.productSelectionModal.selectProducts"),
  size = "default",
}) => {
  const [open, setOpen] = useState(false);
  const selectedCount = selectedProducts.length;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          disabled={disabled}
          size={size}
          className={size === "default" ? "w-full" : ""}
        >
          <Package className="h-4 w-4 mr-2" />
          {triggerText}
          {selectedCount > 0 && (
            <span className="ml-2 bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
              {selectedCount}
            </span>
          )}
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-7xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex-1 overflow-auto">
          <ProductSelectionSection
            selectedProducts={selectedProducts}
            onProductsChange={onProductsChange}
            showPricing={showPricing}
            disabled={disabled}
            className="p-1"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
